import { Button, Card } from '@/components/Bicester';
import { Form } from '@/components/formik-rsuite';
import { isAfter } from 'date-fns';
import { FormikProvider, useFormik } from 'formik';
import React from 'react';
import { ItemDataType } from 'rsuite5/esm/@types/common';
import { APPROVED_TYPE, ApproveStatus } from '../Examine/constants';
import _ from 'lodash';
import ImageMagnifier from './ImageMagnifier';
import { getImagePath } from '@/utils/imageUtils';
import { LEVEL_TYPE, ROLE_TYPE } from '@/constants';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { ACCOUNT_TABS } from '@/views/CustomerAccount';
import { IconButton } from 'rsuite';
import Image from '@/components/Bicester/Image';
import { getPathname } from '@/utils/history';

/** 单卡片高度485px */
const ExamineCard = ({
  data,
  brandList,
  pcsList,
  salesSource,
  showModal,
  setShowModal,
  onApproved,
}: {
  data: any;
  brandList: ItemDataType[];
  pcsList: ItemDataType[];
  salesSource: ItemDataType[];
  showModal: any;
  setShowModal: (showModal: any) => void;
  onApproved: (approved: -1 | 1, params: any) => void;
}) => {
  const { profile } = useReadyInfo();
  const readOnly = data?.approved !== APPROVED_TYPE.PENDING;
  const formik = useFormik({
    initialValues: _.pick(data, [
      'id',
      'tran_id',
      'ocr_error_reason',
      'approved',
      'media_id',
      'shopping_village',
      'price',
      'name',
      'brand_id',
      'consume_time',
      'create_at',
      'type',
      'pcs_id',
      'sales_source',
    ]),
    enableReinitialize: true,
    onSubmit(values) {
      console.log(values);
    },
  });

  return (
    <div className="w-full p-[20px] pt-[10px] border border-solid border-[#979797]">
      <div className="w-[40%] flex">
        <div className="text-[#999999] mr-[6px]">ID</div>
        <div className="mr-auto">{data?.id || ''}</div>
        <div>{ApproveStatus?.[data?.approved] || ''}</div>
      </div>
      <FormikProvider value={formik}>
        <Form>
          <div className="flex h-[557px]">
            <div className="w-[50%] flex justify-center items-center mr-[10px]">
              <ImageMagnifier
                thumb={getImagePath(data?.media_id || '/resources/images/sample-receipt-SH.png')}
                original={getImagePath(data?.media_id || '/resources/images/sample-receipt-SH.png')}
              />
            </div>
            <Card className="w-[50%]">
              <Card.Input
                notEditable
                label="小票编号"
                formKey="tran_id"
                contentOverflow="ellipsis-popover"
              />
              <Card.Input
                notEditable
                label="审核原因"
                formKey="ocr_error_reason"
                contentOverflow="ellipsis-popover"
              />
              <Card.Picker
                isEdit={!readOnly}
                label="购物村"
                formKey="shopping_village"
                pickerType="village"
              />
              <Card.Input
                isEdit={!readOnly}
                label="金额"
                formKey="price"
                inputType="price"
                contentOverflow="nowrap"
              />
              <Card.Input
                notEditable
                label="用户名"
                formKey="name"
                contentOverflow="nowrap"
                autoWidth
                hasBtn={Boolean(data?.member_id || data?.not_member_id)}
                customBtn={
                  <IconButton
                    className="flex-1"
                    onClick={() => {
                      const isMember = data?.level !== LEVEL_TYPE.NOT;
                      window.open(
                        getPathname(
                          `/customer-account/${
                            isMember ? ACCOUNT_TABS.MEMBER : ACCOUNT_TABS.NO_MEMBER
                          }/detail/${isMember ? data?.member_id : data?.not_member_id}`
                        )
                      );
                    }}
                  >
                    <Image
                      src={`/resources/images/user${
                        data?.sex === '男' ? '-man' : data?.sex === '女' ? '-woman' : ''
                      }.svg`}
                    />
                  </IconButton>
                }
              />
              <Card.Picker
                isEdit={!readOnly}
                label="品牌"
                formKey="brand_id"
                pickerData={brandList}
                placement="bottomEnd"
                menuMaxHeight={200}
                value={data?.brand}
                searchable
              />
              <Card.DatePicker
                isEdit={!readOnly}
                label="消费时间"
                formKey="consume_time"
                disabledDate={(date) => isAfter(date, new Date())}
                placement="bottomEnd"
              />
              <Card.Picker
                notEditable
                label="上传时间"
                formKey="create_at"
                value={data?.create_at}
              />
              <Card.Input
                notEditable
                label="小票来源"
                formKey="type"
                value={data?.type}
                contentOverflow="nowrap"
              />
              <Card.Picker
                isEdit={profile?.role === ROLE_TYPE.DRT && !readOnly}
                label="所属导购大使"
                formKey="pcs_id"
                pickerData={pcsList}
                placement="topEnd"
                menuMaxHeight={200}
                value={data?.pcs_name}
                searchable
              />
              <Card.Picker
                isEdit={profile?.role === ROLE_TYPE.DRT && !readOnly}
                label="销售渠道"
                formKey="sales_source"
                pickerData={salesSource}
                placement="topEnd"
                menuMaxHeight={200}
                value={data?.sales_source_name}
                searchable
              />
              {data?.approved === APPROVED_TYPE.REFUSE && (
                <Card.Input
                  notEditable
                  label="拒绝原因"
                  formKey="refuse_desc"
                  value={data?.refuse_desc}
                />
              )}
              {!readOnly && (
                <div className="flex mt-[7px]">
                  <Button
                    className="h-[33px] leading-[33px] flex-1 p-0 mr-[6px]"
                    disabled={readOnly}
                    onClick={() => onApproved(1, formik.values)}
                  >
                    通过
                  </Button>
                  <Button
                    className="h-[33px] leading-[33px] flex-1 p-0"
                    disabled={readOnly}
                    onClick={() =>
                      setShowModal({ ...showModal, show: true, params: formik.values })
                    }
                  >
                    拒绝
                  </Button>
                </div>
              )}
            </Card>
          </div>
        </Form>
      </FormikProvider>
    </div>
  );
};

export default ExamineCard;
